import MagaluService, { isSuccess } from '@magalu/webzord';
export var useRequestUserCredential = function (logger) {
    if (logger === void 0) { logger = console; }
    return new Promise(function (resolve, reject) {
        try {
            MagaluService.request({
                callback: function (result) {
                    if (isSuccess(result)) {
                        logger.debug('[useRequestUserCredential] - success', result);
                        resolve(result === null || result === void 0 ? void 0 : result.body);
                    }
                    else {
                        logger.error('[useRequestUserCredential] - error', result);
                        reject(result);
                    }
                },
                callbackId: 'login',
                serviceArgs: {
                    authId: '',
                },
                serviceName: 'customer.requestCredentials',
            });
        }
        catch (e) {
            logger.error('[useRequestUserCredential] - error - catch', e);
            reject(e);
        }
    });
};
